module.exports = __webpack_public_path__ + "img/jiangsubanner.3cf44510.png";